<template>
    <div>
        <v-form ref="form" class="agency-budget">
            <egranty-section-divider icon="attach_money" :text="'Budżet'" />


            <v-layout row wrap>
                <v-flex d-flex xs4>
                    <v-card color="grey lighten-1">
                        <v-card-text style="padding-right: 8px"><strong>Działania</strong>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Środki z
                                MSZ</strong>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
                            <strong>Paragraf</strong>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text><strong>Środki z innych źródeł</strong></v-card-text>
                    </v-card>
                </v-flex>

                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text><strong>Wszystkie źródła</strong></v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout v-for="(cost, index) in costs" :key="index">
                <v-flex d-flex xs4>
                    <v-card class="agency-actions-costs-layout" color="grey lighten-5" style="width: 100%">
                        <v-layout row wrap align-center>
                            <div class="agency-action-costs-v-select-icon">
                                <v-select class="ma-2 cost-name" :disabled="true" :items="actions"
                                    label="Działanie, którego dotyczy koszt" item-value="id" item-text="action"
                                    aria-label="action" v-model="cost.actionId" @input="sync"
                                    :data-vv-name="'actions' + index" data-vv-as="Działania"
                                    :error-messages="vErrors.collect('actions' + index)"
                                    v-validate="'required'"></v-select>
                                <egranty-icon-button v-if="!readonly" color="lightred" icon="delete"
                                    label="Usuń to działanie"></egranty-icon-button>
                            </div>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-5">
                        <div class="ma-2">
                            <egranty-number-input-field class="amount" :disabled="true" v-model="cost.mszFundings"
                                :label="currencyCode === '' ? 'kwota w PLN' : 'kwota w ' + currencyCode"
                                @input="sync"></egranty-number-input-field>
                        </div>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-5" width="100%">
                        <v-select class="ma-2 amount paragraph-amount" :disabled="true" :items="paragraphs"
                            label="Paragraf" aria-label="paragraph" item-value="id" item-text="name"
                            v-model="cost.paragraphId" @input="sync" :data-vv-name="'paragraph' + index"
                            data-vv-as="Paragraf" :error-messages="vErrors.collect('paragraph' + index)"
                            v-validate="'required'"></v-select>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-5">
                        <div class="ma-2">
                            <egranty-number-input-field class="amount" :disabled="true" v-model="cost.ownFundings"
                                :label="currencyCode === '' ? 'kwota w PLN' : 'kwota w ' + currencyCode"
                                @input="sync"></egranty-number-input-field>
                        </div>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-5">
                        <div class="ma-2 total-funding">
                            {{ calculateTotalFundingForCost(cost) }}
                        </div>
                    </v-card>
                </v-flex>
            </v-layout>

            <div v-for="paragraph in paragraphs" :key="paragraph.arrayId">
                <v-layout v-if="paragraph.totalFundings">
                    <v-flex d-flex xs4>
                        <v-card color="grey lighten-1">
                            <v-layout row>
                                <v-card-text style="padding-right: 8px"><strong>Suma ({{ paragraph.name }})</strong>
                                </v-card-text>
                            </v-layout>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex xs2>
                        <v-card color="grey lighten-1">
                            <v-card-text class="amount"
                                style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>{{ formatMoney(paragraph.totalMszFundingsForParagraph) }}</strong>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex xs2>
                        <v-card color="grey lighten-1">
                            <v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex xs2>
                        <v-card color="grey lighten-1">
                            <v-card-text class="amount">
                                <strong>{{ formatMoney(paragraph.totalOwnFundingsForParagraph) }}</strong>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex xs2>
                        <v-card color="grey lighten-1">
                            <v-card-text class="amount">
                                <strong>{{ formatMoney(paragraph.totalFundings) }}</strong>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </div>
            <v-layout row wrap>
                <v-flex d-flex xs4>
                    <v-card color="grey lighten-1">
                        <v-card-text style="padding-right: 8px"><strong>Suma (łącznie)</strong>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"
                            class="amount"><strong>{{ formatMoney(totalMszFundings) }}</strong>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text class="amount"><strong>{{ formatMoney(totalOwnFundings) }}</strong></v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex xs2>
                    <v-card color="grey lighten-1">
                        <v-card-text class="amount"><strong>{{ formatMoney(totalFundings) }}</strong></v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <div class="mt-2">
                <offer-button v-if="!readonly" text="Dodaj kolejny koszt"></offer-button>
            </div>

        </v-form>

    </div>
</template>

<script>
import OfferButton from "../../offer/components/OfferButton";
import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";

import { Numbers } from "../../../../utils/Numbers";
import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";

export default {
    name: "AgencyActionsCostsEmpty",
    components: {
        EgrantySectionDivider,
        EgrantyIconButton, EgrantyNumberInputField, OfferButton,
    },

    created() {
        this.addCost();

    },

    data() {
        return {
            error: '',
            costs: [],
            paragraphs: [],
            currencyCode: ''
        };
    },

    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val === undefined) return;
                // Upewniamy się że val jest tablicą
                this.costs = Array.isArray(val) ? val : [];
            }
        }
    },

    props: {
        readonly: { default: false },
        value: {},
        actions: [
            {
                "serialNumber": 1,
                "place": "a",
                "action": "a",
                "id": 128576,
                "idFake": false
            }
        ],
        contestId: {}
    },

    mixins: [Numbers],

    computed: {

        totalOwnFundings() {
            return 0;
        },

        totalMszFundings() {
            return 0;
        },

        totalFundings() {
            return this.totalMszFundings + this.totalOwnFundings;
        }
    },

    methods: {
        calculateTotalFundingForCost(cost) {
            let ownFundings = cost.ownFundings === null ? 0 : parseFloat(cost.ownFundings);
            let mszFundings = cost.mszFundings === null ? 0 : parseFloat(cost.mszFundings);
            return Numbers.methods.formatMoney(ownFundings + mszFundings);
        },

        sync() {
            this.error = '';
        },

        emptyCost() {
            return {
                actionId: null,
                mszFundings: null,
                ownFundings: null,
                paragraphId: null
            };
        },

        addCost() {
            if (!Array.isArray(this.costs)) {
                this.costs = [];
            }
            this.costs.push(this.emptyCost());
            this.sync();
        },

    },


};
</script>

<style scoped>
.theme--dark .grey.lighten-5 {
    background-color: #1B1B1B !important;
}

.agency-action-costs-v-select-icon {
    display: flex;
    width: 100%;
}
</style>